import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

interface BrandProps {
  compact?: boolean;
  className?: string;
}

export function Brand({ compact = false, className }: BrandProps) {
  return (
    <Link to="/" className={cn('inline-flex min-h-11 items-center gap-2.5 rounded-lg', className)} aria-label="Permiso VTC Madrid, inicio">
      <span className="grid size-9 place-items-center rounded-xl bg-primary text-sm font-black tracking-tight text-primary-foreground shadow-sm">
        VTC
      </span>
      {!compact && (
        <span className="leading-tight">
          <span className="block font-semibold tracking-tight">Permiso VTC</span>
          <span className="block text-[0.68rem] font-medium uppercase tracking-[0.16em] text-muted-foreground">Madrid</span>
        </span>
      )}
    </Link>
  );
}
